export default __webpack_public_path__ + "static/media/bN.46c4b3a9.svg";